import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import {
  InteractionStatus,
} from "@azure/msal-browser";
import { useError } from "../components/ErrorContext";

const useFetchMsal = (): ((method: string, url: string, data?: any) => Promise<any>) => {

  const { setError } = useError(); // Get the error handler
  const { instance, inProgress } = useMsal();
  return (method, url, data) => {
    const promise = new Promise(function (myResolve, myReject) {
      if (inProgress === InteractionStatus.None) {
        instance
          .acquireTokenSilent({
            ...loginRequest,
            account: instance.getActiveAccount() ?? undefined,
          })
          .then((accessTokenResponse) => {
            let accessToken = accessTokenResponse.accessToken;

            // Call your API with token
            const headers = new Headers();
            const bearer = `Bearer ${accessToken}`;
            headers.append("Authorization", bearer);
            if (data) {
              headers.append('Content-Type', 'application/json');
            }

            let options = {
              method: method,
              headers: headers,
              body: data ? JSON.stringify(data) : null,
            };
            fetch(url, options)
              .then(async (value) => {
                if (value.ok === false) {
                  var res = await value.text();
                  setError(`Backend error ${res}`);
                  myReject(res);
                } else {
                  if (value.status !== 204) {
                    var resp = await value.json();
                    myResolve(resp);
                  } else {
                    myResolve({});
                  }
                }
              })
            .catch((error) => {
              setError(error);
              myReject(error);
            });
          })
          .catch((error) => {
            setError(error);
            myReject(error);
          });
      } else {
        setError("Previous interaction in progress.");
        myReject("Previous interaction in progress.");
      }
    });

    return promise;
  };
};

export default useFetchMsal;
